import base from '@/api/base'

export default {
  getStatusReadyTemplate(id) {
    return base.get(`/me/backend/email-templates/order-status-ready/${id}`)
  },
}
